var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicle4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125.466,
    height: 89.205,
    viewBox: "0 0 125.466 89.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(-422.357 -3328.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(-101.729 2603.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11562",
    "data-name": "Path 11562",
    d: "M615.275,795.239a15.291,15.291,0,0,0-9.51-8.5,14.868,14.868,0,0,0-17.451,7.081c-.731,1.336-1.48,2-2.981,1.733a4.278,4.278,0,0,0-.892.062v6.8h-19.7v-6.966c-2.278.689-2.995-.706-3.913-2.231a14.836,14.836,0,0,0-15.535-6.858,15,15,0,0,0-11.847,11.505c-.2.917-.536,1.2-1.417,1.163-1.4-.056-2.8.04-4.2-.055-.364-.025-.974-.494-1-.8-.36-4.224-.638-8.455-.947-12.853h2.627l-.242-2.557-2.814-.148c-.455-5.385-.9-10.689-1.371-16.258,2.46.742,2.764-.9,3.29-2.437,1.766-5.142,3.6-10.262,5.394-15.392.17-.485.293-.985.439-1.482-2.732-.66-2.732-.66-3.065-3.707h26.421v4.992h3.493v-7.361c1.55.29,1.951-.563,2.423-1.755,1.319-3.324,3.99-4.909,7.62-5.254v3.249c-2.2.318-3.96,1.278-4.753,3.646l1.65.155v36.918h3.429V767.065l7.015-1.744v12.574h21.09c-.638-.373-1.06-.64-1.5-.874-5.024-2.661-10.067-5.289-15.059-8.009a3.5,3.5,0,0,1-1.4-1.774c-.513-1.388-.81-2.856-1.252-4.493-1.89.463-3.737.909-5.58,1.371-2.816.705-4.343-.234-5.088-3.141-.655-2.558.372-4.232,3.047-4.934,1.765-.464,3.534-.907,5.466-1.4-.42-1.666-.855-3.267-1.209-4.885a1.944,1.944,0,0,1,.14-1.325q5.345-8.426,10.766-16.8c.044-.069.16-.091.379-.208l12.27,46.523h2.977l-12.839-48.774,16.962-4.491c4.365,16.563,8.711,33.057,13.1,49.693L607.04,777.74l.031.2H629.5v-11.7l-7.178,6.675L609.6,724.666l19.891,4.777.175-2.306h19.885l-5.888,5.908c2.833-.186,2.984,1.562,3.322,3.3.63,3.259,1.437,6.484,2.072,9.741a2.251,2.251,0,0,1-.492,1.724c-2.157,2.277-4.423,4.449-6.6,6.708a2.6,2.6,0,0,0-.753,1.582c-.048,7.093-.03,14.186-.025,21.279a5.11,5.11,0,0,0,.091.6h6.772v2.464H556.68v2.175h89.057v18.55c-1.064.391-1.528.147-1.613-1.1a14.969,14.969,0,0,0-28.159-6.051C615.763,794.39,615.549,794.755,615.275,795.239ZM549.6,746.82c-4.5,0-8.836-.027-13.168.048-.363.006-.885.631-1.044,1.072-1.872,5.2-3.69,10.421-5.517,15.638-.311.886-.6,1.781-.962,2.878L549.6,764.4Zm7.13,4v18.91H560v-18.91Zm3.241,27.141v-5.7h-3.278v5.7Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11563",
    "data-name": "Path 11563",
    d: "M620.752,832.717a12.79,12.79,0,1,1,12.24,12.872A12.733,12.733,0,0,1,620.752,832.717Zm18.483.185a5.72,5.72,0,1,0-5.708,5.729A5.8,5.8,0,0,0,639.235,832.9Z",
    transform: "translate(-32.124 -31.72)",
    fill: "#F26A1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11564",
    "data-name": "Path 11564",
    d: "M553.686,820.109a12.74,12.74,0,1,1-12.761,12.637A12.793,12.793,0,0,1,553.686,820.109Zm5.722,12.746a5.72,5.72,0,1,0-5.651,5.773A5.806,5.806,0,0,0,559.408,832.855Z",
    transform: "translate(-5.596 -31.718)",
    fill: "#F26A1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11565",
    "data-name": "Path 11565",
    d: "M675.185,820.109A12.74,12.74,0,1,1,662.4,832.723,12.792,12.792,0,0,1,675.185,820.109Zm5.7,12.686a5.72,5.72,0,1,0-5.736,5.834A5.806,5.806,0,0,0,680.884,832.795Z",
    transform: "translate(-45.965 -31.718)",
    fill: "#F26A1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11566",
    "data-name": "Path 11566",
    d: "M552,757.845v17.582l-20.691,2.055c.366-1.1.652-1.992.962-2.878,1.827-5.217,3.646-10.437,5.517-15.638.159-.441.681-1.066,1.044-1.072C543.163,757.818,547.5,757.845,552,757.845Z",
    transform: "translate(-2.4 -11.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11567",
    "data-name": "Path 11567",
    d: "M572.977,763.833h3.274v18.91h-3.274Z",
    transform: "translate(-16.248 -13.016)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11568",
    "data-name": "Path 11568",
    d: "M576.2,801.645h-3.278v-5.7H576.2Z",
    transform: "translate(-16.229 -23.687)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle4);
export default __webpack_public_path__ + "static/media/vehicle-4.9d1d6a733683d36d4bba4929d3e2bbc4.svg";
export { ForwardRef as ReactComponent };